export const getBaseUrl = () => {
  const val = window.location.hostname;
  let modifiedArray = val;
  if (val.includes("://")) {
    // This will very likely not trigger , because the hostname will very likely not match the form of the string
    const strippedVal = modifiedArray.split("://");
    strippedVal.splice(0, 1).join("");
    modifiedArray = strippedVal.join("");
  }
  const splittedString = modifiedArray.split(".");
  const reversedArray = splittedString.reverse();
  return `${reversedArray[1]}.${reversedArray[0]}`;
};

export const getEventBaseUrl = () => {
  const val = window.location.hostname;
  if(val.includes("localhost")){
    return "localhost:3000"
  }
  return val
}
